var Model = require('../Model');

var Comment = Object.create(Model);

Comment.name = 'Comment';
Comment.parentClass = 'Event';
Comment.url = 'comment';
Comment['@class'] = 'Comment';
Comment.fields = {
  subjectRecord: {
    // Subject record is the record this comment is about.  An incident @rid is an example.
    hidden: true
  },
  deleted: {
    type: 'boolean',
    hidden: true
  },
  timestamp: {
    validators: {
      presence: true
    }
  },
  updatedTimestamp: {},
  message: {
    type: 'textarea'
  },
  elementRid: {}
};

module.exports = Comment;
